import { getDataMapper, mapArray, mapField } from "@/shared";

export const mapDirectorCallFromServer = getDataMapper({
    id: mapField("id", Number),
    comment: mapField("comment"),
    callDate: mapField("call_date"),
    status: mapField("status"),
    manager: mapField("manager"),
    createdAt: mapField("created_at"),
});

export const mapDirectorCallsFromServer = mapArray(mapDirectorCallFromServer);
